import React from 'react';
import { styles } from './DeleteConfirmationModal.styles.js';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import Modal from '../Modal/Modal.js';
import ModalContent from '../Modal/ModalContent/ModalContent.js';
import ModalHeader from '../Modal/ModalHeader/ModalHeader.js';
import ModalFooter from '../Modal/ModalFooter/ModalFooter.js';
import Button from '../Button/Button.js';
import ModalBody from '../Modal/ModalBody/ModalBody.js';

var DeleteConfirmationModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onDelete = _a.onDelete;
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose },
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, { onClose: onClose },
                React.createElement("div", { className: styles.titleContainer },
                    React.createElement(ReportProblemRoundedIcon, { htmlColor: "#BF2600", className: styles.titleDangerIcon }),
                    "Confirm deletion")),
            React.createElement(ModalBody, { className: styles.modalBody },
                React.createElement(ReportProblemRoundedIcon, { htmlColor: "#BF2600", className: styles.bodyDangerIcon }),
                React.createElement("div", null, "Are you sure you want to proceed?")),
            React.createElement(ModalFooter, { className: styles.modalFooter },
                React.createElement(Button, { onClick: onClose, color: "unset", size: "unset" }, "Cancel"),
                React.createElement(Button, { onClick: onDelete, color: "unset", className: styles.primaryButton }, "Delete")))));
};

export { DeleteConfirmationModal as default };
//# sourceMappingURL=DeleteConfirmationModal.js.map
